import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { DiffEditor } from '@monaco-editor/react';

interface DiffViewerProps {
  open: boolean;
  onClose: () => void;
  original: string;
  modified: string;
  title?: string;
}

const DIFF_OPTIONS = {
  readOnly: true,
  renderSideBySide: true,
  minimap: { enabled: false },
  lineNumbers: 'on' as const,
  wordWrap: 'on' as const,
  fontSize: 13,
  scrollBeyondLastLine: false,
  automaticLayout: true,
  renderOverviewRuler: false,
};

export function DiffViewer({ open, onClose, original, modified, title }: DiffViewerProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-[90vw] h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <div className="flex items-center justify-between">
            <DialogTitle>{title || 'Compare Versions'}</DialogTitle>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </DialogHeader>

        {/* Labels */}
        <div className="flex border-b bg-muted/50">
          <div className="flex-1 px-4 py-1">
            <span className="text-xs font-semibold text-muted-foreground">Original</span>
          </div>
          <div className="flex-1 px-4 py-1 border-l">
            <span className="text-xs font-semibold text-muted-foreground">Modified</span>
          </div>
        </div>

        {/* Diff Editor */}
        <div className="flex-1 min-h-0">
          <DiffEditor
            height="100%"
            language="markdown"
            original={original}
            modified={modified}
            options={DIFF_OPTIONS}
            theme="vs"
          />
        </div>

        <DialogFooter className="flex-shrink-0">
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DiffViewer;
